import React, { FC } from 'react';
import { TableBody, TableCell } from "@mui/material";
import { ProjectResponse } from '@api/projects/mutations';
import { EmptyRow, RenderRow } from '@components/create-project/table/helpers';
import { useTranslation } from 'react-i18next';

interface FinancialCalculationsTableProps {
  offer: ProjectResponse;
}

export const FinancialCalculationsTable: FC<FinancialCalculationsTableProps> = ({offer}) => {
  const {t} = useTranslation();

  return (
    <TableBody>
      <tr>
        <TableCell className="w-full bg-black" sx={{p: "1px 4px", color: "white"}} colSpan={5}>
          {t("project.table.financialCalculation.title")}
        </TableCell>
      </tr>
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticBuilding")}
        name="TIC Building"
        caseType="FC"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticTech")}
        name="TIC Tech + Earthworks"
        caseType="FC"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticEarthworks")}
        name="TIC Tech + Earthworks"
        caseType="FC"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticNetworkInfrastructure")}
        name="TIC Network Infrastructure"
        caseType="FC"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticMgmtContingencies")}
        name="TIC Mgmt + Contingencies"
        caseType="FC"
        units="EUR"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.tic")}
        name="TIC"
        caseType="FC"
        units="EUR"
        fontWeight={700}
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.ticSpecific")}
        name="TIC specific"
        caseType="FC"
        units="EUR/m2"
        fontStyle="italic"
      />
      <EmptyRow/>
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.subsidyPublicGrant")}
        name="Subsidy/Public Grant (assumed)"
        caseType="FC"
        units="EUR"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.bankLoan")}
        name="Bank Loan"
        caseType="FC"
        units="EUR"
        underline
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.bkzTicContributionByCustomer")}
        name="BKZ (TIC contribution by customer)"
        caseType="FC"
        units="EUR"
        fontWeight={700}
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.bkzPerUnit")}
        name="BKZ per unit"
        caseType="FC"
        units="EUR/unit"
        fontStyle="italic"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.bkzSpecific")}
        name="BKZ specific"
        caseType="FC"
        units="EUR/m2"
        fontStyle="italic"
      />
      <RenderRow
        offer={offer}
        label={t("project.table.financialCalculation.bkzToTicRatio")}
        name="BKZ-to-TIC Ratio"
        caseType="FC"
        units="%"
        fontStyle="italic"
      />
    </TableBody>
  );
};
